module.exports = __webpack_public_path__ + "img/Super.02a7f123.jpg";